import { render, staticRenderFns } from "./ContactUsIndependent.vue?vue&type=template&id=5f4b900b"
import script from "./ContactUsIndependent.vue?vue&type=script&lang=js"
export * from "./ContactUsIndependent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports